import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IOrganizationAccess } from "src/app/shared/interfaces/access.interface";
import { ApiService } from "src/app/shared/services/api.service";

@Injectable({
  providedIn: "root",
})
export class HandleLinkService {
  constructor(private api: ApiService) {}

  /**
   * Handles link redirection
   * @param token Token for specific action
   * @return Access and refresh tokens for the verified organization, along with the
   * functionalities and routes the user's role in that organization grants access to
   */
  public handleLink(token: string): Observable<IOrganizationAccess> {
    return this.api.get(
      "handle-link",
      {
        token: token,
      },
      false
    ) as Observable<IOrganizationAccess>;
  }
}
